export default __webpack_public_path__ + "static/media/detox4.a16ebb47.jpeg";